export const SET_EDITEDSERVICE = "EDITEDSERVICE/SET_EDITEDSERVICE";
